export const ACTIVE = 'active';
export const CANCELED = 'canceled';

export const statuses = [ ACTIVE, CANCELED ];
